import { PROCESS_STATUS } from 'consts';
import { HTTP } from 'services/http';

export function getInfoboxMessageForStatus(processStatus: number) {
	switch (processStatus) {
		case PROCESS_STATUS.InSigning:
			return 'contract_sended';
		case PROCESS_STATUS.PrintedContractForManualSigning:
			return 'contract_printed';
		default:
			return '';
	}
}

export function startSigning(http: HTTP, id: string, endpoint: string, message: string, isManualSigning = false) {
	const qs = isManualSigning ? '?isManualSigning=true' : '';
	const url = `${endpoint}/${id}${qs}`;
	return http.post(url, {}, message);
}

export function getSigningIdInLoop(http: HTTP, url: string) {
	return new Promise((resolve, reject) => {
		getSigningId(http, url, resolve, reject);
	});
}

function getSigningId(http: HTTP, url: string, resolve: (res: unknown) => void, reject: (reason?: any) => void) {
	if (false === window.location.pathname.endsWith('/sign')) {
		return reject('SIGNING SKIPED: url changed');
	}
	http.get(url).then((res: { processInfo: { signingId: string | null } }) => {
		if (res?.processInfo?.signingId?.length) {
			return resolve(res);
		} else {
			setTimeout(() => {
				getSigningId(http, url, resolve, reject);
			}, 9_000);
		}
	});
}
